module.exports = __webpack_public_path__ + "images/pos_icon.ab8419dcb0458e4464a122af0d074c33.png";